/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'reaction-sad': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<defs><path pid="0" d="M10 0C4.489 0 0 4.489 0 10s4.489 10 10 10 10-4.489 10-10S15.511 0 10 0zm0 2c4.43 0 8 3.57 8 8s-3.57 8-8 8-8-3.57-8-8 3.57-8 8-8zM7 7a1 1 0 100 2 1 1 0 000-2zm3 5c1.322 0 2.532.403 3.598 1.198a1 1 0 11-1.196 1.604A3.897 3.897 0 0010 14c-.89 0-1.68.263-2.402.802a1 1 0 11-1.196-1.604A5.896 5.896 0 0110 12zm3-5a1 1 0 110 2 1 1 0 010-2z" id="svgicon_reaction-sad_a"/></defs><g _fill="none" fill-rule="evenodd"><mask id="svgicon_reaction-sad_b" _fill="#fff"><use xlink:href="#svgicon_reaction-sad_a"/></mask><path pid="1" _fill="#22262A" fill-rule="nonzero" mask="url(#svgicon_reaction-sad_b)" d="M-2-2h24v24H-2z"/></g>'
  }
})
